var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonEndPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 26C15.2 14 5 3.66667 0 0H43.5V42C35.5 31.5 21.5 27 16 26Z",
    fill: "#F6821F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 42C25.4 34 14.5 32.6666 10 33H6.5V42H33Z",
    fill: "#F6821F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonEndPattern);
export default __webpack_public_path__ + "static/media/buttonEndPattern.1de5d1a726a99c4b25ba1e577e314720.svg";
export { ForwardRef as ReactComponent };